import { IUser } from '@/features/user/store/user.model';

import { IKycDocument, IKycDocumentPreview } from '@/features/kyc/store/models/kyc.model';
import { IPayin } from '@/store/models/payin.model';
import { TAppError, IBaseAction } from '@/store/types/base.state';

export enum ProfileKycActionTypes {
  GET_KYC_PROFILE_PAYINS = 'PROFILE.GET_KYC_PROFILE_PAYINS',
  GET_KYC_PROFILE_PAYINS_FAIL = 'PROFILE.GET_KYC_PROFILE_PAYINS_FAIL',
  GET_KYC_PROFILE_PAYINS_SUCCESS = 'PROFILE.GET_KYC_PROFILE_PAYINS_SUCCESS',

  GET_KYC_DOCUMENTS = 'PROFILE.GET_KYC_DOCUMENTS',
  GET_KYC_DOCUMENTS_SUCCESS = 'PROFILE.GET_KYC_DOCUMENTS_SUCCESS',
  GET_KYC_DOCUMENTS_FAIL = 'PROFILE.GET_KYC_DOCUMENTS_FAIL',

  REMOVE_KYC_DOCUMENT = 'PROFILE.REMOVE_KYC_DOCUMENT',
  REMOVE_KYC_DOCUMENT_SUCCESS = 'PROFILE.REMOVE_KYC_DOCUMENT_SUCCESS',
  REMOVE_KYC_DOCUMENT_FAIL = 'PROFILE.REMOVE_KYC_DOCUMENT_FAIL',

  ADD_KYC_DOCUMENT = 'PROFILE.ADD_KYC_DOCUMENT',
  ADD_KYC_DOCUMENT_SUCCESS = 'PROFILE.ADD_KYC_DOCUMENT_SUCCESS',
  ADD_KYC_DOCUMENT_FAIL = 'PROFILE.ADD_KYC_DOCUMENT_FAIL',

  EDIT_KYC_DOCUMENT = 'PROFILE.EDIT_KYC_DOCUMENT',
  EDIT_KYC_DOCUMENT_SUCCESS = 'PROFILE.EDIT_KYC_DOCUMENT_SUCCESS',
  EDIT_KYC_DOCUMENT_FAIL = 'PROFILE.EDIT_KYC_DOCUMENT_FAIL',

  GET_KYC_DOCUMENT_PREVIEW = 'PROFILE.GET_KYC_DOCUMENT_PREVIEW',
  GET_KYC_DOCUMENT_PREVIEW_SUCCESS = 'PROFILE.GET_KYC_DOCUMENT_PREVIEW_SUCCESS',
  GET_KYC_DOCUMENT_PREVIEW_FAIL = 'PROFILE.GET_KYC_DOCUMENT_PREVIEW_FAIL',

  SUBMIT_KYC = 'PROFILE.SUBMIT_KYC',
  SUBMIT_KYC_SUCCESS = 'PROFILE.SUBMIT_KYC_SUCCESS',
  SUBMIT_KYC_FAIL = 'PROFILE.SUBMIT_KYC_FAIL',

  ADD_CHILD_KYC_DOCUMENT = 'PROFILE.ADD_CHILD_KYC_DOCUMENT',
  ADD_CHILD_KYC_DOCUMENT_SUCCESS = 'PROFILE.ADD_CHILD_KYC_DOCUMENT_SUCCESS',
  ADD_CHILD_KYC_DOCUMENT_FAIL = 'PROFILE.ADD_CHILD_KYC_DOCUMENT_FAIL',
}

export interface IGetKycDocumentsAction extends IBaseAction {
  type: typeof ProfileKycActionTypes.GET_KYC_DOCUMENTS;
  userId: number;
}

export interface IGetKycDocumentsSuccessAction extends IBaseAction {
  type: typeof ProfileKycActionTypes.GET_KYC_DOCUMENTS_SUCCESS;
  documents: IKycDocument[];
  userId: number;
}

export interface IGetKycDocumentsFailAction extends IBaseAction {
  type: typeof ProfileKycActionTypes.GET_KYC_DOCUMENTS_FAIL;
  userId: number;
  error: TAppError;
}

export interface IRemoveKycDocumentAction extends IBaseAction {
  type: typeof ProfileKycActionTypes.REMOVE_KYC_DOCUMENT;
  document: IKycDocument;
}

export interface IRemoveKycDocumentSuccessAction extends IBaseAction {
  type: typeof ProfileKycActionTypes.REMOVE_KYC_DOCUMENT_SUCCESS;
  document: IKycDocument;
}

export interface IRemoveKycDocumentFailAction extends IBaseAction {
  type: typeof ProfileKycActionTypes.REMOVE_KYC_DOCUMENT_FAIL;
  document: IKycDocument;
  error: TAppError;
}

export interface IAddKycDocumentAction extends IBaseAction {
  type: typeof ProfileKycActionTypes.ADD_KYC_DOCUMENT;
  userId: number;
  batchIndex?: string;
}

export interface IAddKycDocumentSuccessAction extends IBaseAction {
  type: typeof ProfileKycActionTypes.ADD_KYC_DOCUMENT_SUCCESS;
  document: IKycDocument;
  batchIndex?: string;
}

export interface IAddKycDocumentFailAction extends IBaseAction {
  type: typeof ProfileKycActionTypes.ADD_KYC_DOCUMENT_FAIL;
  userId: number;
  error: TAppError;
  batchIndex?: string;
}
export interface IEditKycDocumentAction extends IBaseAction {
  type: typeof ProfileKycActionTypes.EDIT_KYC_DOCUMENT;
  document: IKycDocument;
}
export interface IEditKycDocumentSuccessAction extends IBaseAction {
  type: typeof ProfileKycActionTypes.EDIT_KYC_DOCUMENT_SUCCESS;
  document: IKycDocument;
}

export interface IEditKycDocumentFailAction extends IBaseAction {
  type: typeof ProfileKycActionTypes.EDIT_KYC_DOCUMENT_FAIL;
  document: IKycDocument;
  error: TAppError;
}
export interface IGetKycDocumentPreviewAction extends IBaseAction {
  type: typeof ProfileKycActionTypes.GET_KYC_DOCUMENT_PREVIEW;
  userId: number;
  document: IKycDocument;
}

export interface IGetKycDocumentPreviewSuccessAction extends IBaseAction {
  type: typeof ProfileKycActionTypes.GET_KYC_DOCUMENT_PREVIEW_SUCCESS;
  userId: number;
  document: IKycDocument;
  preview: IKycDocumentPreview;
}

export interface IGetKycDocumentPreviewFailAction extends IBaseAction {
  type: typeof ProfileKycActionTypes.GET_KYC_DOCUMENT_PREVIEW_FAIL;
  userId: number;
  document: IKycDocument;
  error: TAppError;
}

export interface ISubmitKycAction extends IBaseAction {
  type: typeof ProfileKycActionTypes.SUBMIT_KYC;
  userId: number;
}

export interface ISubmitKycSuccessAction extends IBaseAction {
  type: typeof ProfileKycActionTypes.SUBMIT_KYC_SUCCESS;
  user: IUser;
}

export interface ISubmitKycFailAction extends IBaseAction {
  type: typeof ProfileKycActionTypes.SUBMIT_KYC_FAIL;
  userId: number;
  error: TAppError;
}

export interface IGetProfileKYCsPayinsAction extends IBaseAction {
  type: typeof ProfileKycActionTypes.GET_KYC_PROFILE_PAYINS;
  userId: number;
}

export interface IGetProfileKYCsPayinsSuccessAction extends IBaseAction {
  type: typeof ProfileKycActionTypes.GET_KYC_PROFILE_PAYINS_SUCCESS;
  userId: number;
  payins: IPayin[];
}

export interface IGetProfileKYCsPayinsFailAction extends IBaseAction {
  type: typeof ProfileKycActionTypes.GET_KYC_PROFILE_PAYINS_FAIL;
  userId: number;
  error: TAppError;
}

export interface IAddChildKycDocumentAction extends IBaseAction {
  type: typeof ProfileKycActionTypes.ADD_CHILD_KYC_DOCUMENT;
  userId: number;
  parentId: number;
  batchIndex?: string;
}

export interface IAddChildKycDocumentSuccessAction extends IBaseAction {
  type: typeof ProfileKycActionTypes.ADD_CHILD_KYC_DOCUMENT_SUCCESS;
  document: IKycDocument;
  userId: number;
  parentId: number;
  batchIndex?: string;
}

export interface IAddChildKycDocumentFailAction extends IBaseAction {
  type: typeof ProfileKycActionTypes.ADD_CHILD_KYC_DOCUMENT_FAIL;
  userId: number;
  parentId: number;
  error: TAppError;
  batchIndex?: string;
}

export type TProfileKycAction =
  | IGetProfileKYCsPayinsAction
  | IGetProfileKYCsPayinsSuccessAction
  | IGetProfileKYCsPayinsFailAction
  | IGetKycDocumentsAction
  | IGetKycDocumentsSuccessAction
  | IGetKycDocumentsFailAction
  | IRemoveKycDocumentAction
  | IRemoveKycDocumentSuccessAction
  | IRemoveKycDocumentFailAction
  | IAddKycDocumentAction
  | IAddKycDocumentSuccessAction
  | IAddKycDocumentFailAction
  | IEditKycDocumentAction
  | IEditKycDocumentSuccessAction
  | IEditKycDocumentFailAction
  | IGetKycDocumentPreviewAction
  | IGetKycDocumentPreviewSuccessAction
  | IGetKycDocumentPreviewFailAction
  | ISubmitKycAction
  | ISubmitKycSuccessAction
  | ISubmitKycFailAction
  | IAddChildKycDocumentAction
  | IAddChildKycDocumentSuccessAction
  | IAddChildKycDocumentFailAction;
